import { useState } from 'react';
import AttentionScreen from './attentionScreen';
import RouteForms from './mainRouteFile';
import { useShipForm } from '../../../context/shipForms';
import { useLocation } from 'react-router-dom';
import { ReferenceRouteFormDto } from '../../../types';

interface Props {
  setCurrentShipmentStatus: any;
  isQuote?: boolean;
  setShowRoutes?: any;
}
function MainRoutePage({
  setCurrentShipmentStatus,
  isQuote,
  setShowRoutes,
}: Props) {
  const [showAttention, setShowAttention] = useState(false);
  const [showPackages, setShowPackages] = useState(false);
  const { setIsMetricContext, setSavedQuoteFormDataContext } = useShipForm();
  const location = useLocation();
  const rate_id = new URLSearchParams(location.search).get('rate_id');
  const quoteData = location.state ? location.state.quoteData : null;
  if (rate_id && quoteData) {
    let referenceForm: ReferenceRouteFormDto = {
      reference_1: quoteData?.reference_one,
      reference_2: quoteData?.reference_two,
      project_name: '',
      booking_date: new Date().toISOString(),
    };
    let metricAndFood = {
      isMetric: quoteData?.is_metric,
      isFood: quoteData?.is_food,
    };
    let savedQuoteData = {
      quoteData: quoteData,
      referenceForm: referenceForm,
    };
    setSavedQuoteFormDataContext(savedQuoteData);
    setIsMetricContext(metricAndFood);
  }
  return (
    <>
      {!showAttention ? (
        <RouteForms
          setShowAttention={setShowAttention}
          isQuote={isQuote}
          setShowRoutes={setShowRoutes}
        />
      ) : (
        <AttentionScreen
          isQuote={isQuote}
          showPackages={showPackages}
          setShowAttention={setShowAttention}
          setShowPackages={setShowPackages}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      )}
    </>
  );
}

export default MainRoutePage;
